import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
})
export class TimerComponent implements OnInit, OnDestroy {
  @Input() minutes = 1;
  countDownTimer: Subscription | undefined;
  countDownValue: Date | undefined;

  ngOnInit(): void {
    const seconds = this.minutes * 60;
    this.countDownValue = new Date(0, 0, 0, 0, this.minutes);
    this.countDownTimer = timer(0, 1000).subscribe((t) => {
      const aDate = new Date(0, 0, 0, 0, 0, 59);
      aDate.setSeconds(seconds - t.valueOf());
      this.countDownValue = aDate;
      if (aDate.getMinutes() === 0 && aDate.getSeconds() === 0) {
        this.countDownTimer?.unsubscribe();
      }
    });
  }

  reset(): void {
    this.countDownTimer?.unsubscribe();
    const seconds = this.minutes * 60;
    this.countDownValue = new Date(0, 0, 0, 0, this.minutes);
    this.countDownTimer = timer(0, 1000).subscribe((t) => {
      const aDate = new Date(0, 0, 0, 0, 0, 59);
      aDate.setSeconds(seconds - t.valueOf());
      this.countDownValue = aDate;
      if (aDate.getMinutes() === 0 && aDate.getSeconds() === 0) {
        this.countDownTimer?.unsubscribe();
      }
    });
  }

  ngOnDestroy(): void {
    this.countDownTimer?.unsubscribe();
  }
}
